import React, { useState } from "react";
import { useMap } from "react-leaflet";
import axios from "axios";
import { toast } from "sonner";

/**
 * RecenterMap — MapContainer içine konur. `center` ([lat,lng]) değişince
 * haritayı oraya uçurur. Adres aramada bulunan konuma odaklanmak için.
 */
export function RecenterMap({ center, zoom = 17 }) {
  const map = useMap();
  React.useEffect(() => {
    if (
      Array.isArray(center) &&
      Number.isFinite(center[0]) &&
      Number.isFinite(center[1])
    ) {
      map.flyTo(center, zoom, { duration: 0.8 });
    }
  }, [center, zoom, map]);
  return null;
}

/**
 * MapSearchBox — haritanın üstüne yapışan adres arama kutusu.
 * Adres yazıp "Ara" (veya Enter) → /api/geocode → bulununca onResult(lat,lng,name).
 * MapContainer'ın KARDEŞİ olarak (içinde değil) render edilmeli; kapsayıcı
 * `relative` olmalı.
 *
 * @param {string} apiBase     backend base URL (geocode için)
 * @param {function} onResult  (lat, lng, displayName) bulununca çağrılır
 * @param {string} [placeholder]
 * @param {string} [className] konum/override sınıfları (varsayılan: sol üst)
 */
export function MapSearchBox({
  apiBase,
  onResult,
  placeholder = "Adres ara (örn. 451. cadde)",
  className = "top-2 left-2",
}) {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);

  const doSearch = async () => {
    const query = q.trim();
    if (!query) return;
    setBusy(true);
    try {
      const res = await axios.get(`${apiBase}/api/geocode`, {
        params: { address: query },
      });
      if (res.data && res.data.success) {
        onResult(
          Number(res.data.latitude),
          Number(res.data.longitude),
          res.data.display_name,
        );
      } else {
        toast.error(res.data?.detail || "Adres bulunamadı");
      }
    } catch (e) {
      toast.error(
        e?.response?.data?.detail ||
          "Adres servisi yanıt vermedi, tekrar deneyin.",
      );
    } finally {
      setBusy(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      doSearch();
    }
  };

  return (
    <div
      className={`absolute z-[1000] flex items-center gap-1 bg-white/90 backdrop-blur rounded-md p-1 shadow ${className}`}
    >
      <input
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className="text-xs px-2 py-1 rounded border border-gray-200 outline-none w-40 sm:w-52 focus:border-green-500"
      />
      <button
        type="button"
        onClick={doSearch}
        disabled={busy}
        className="text-xs rounded-md bg-green-600 text-white px-2 py-1 hover:bg-green-700 disabled:opacity-50 whitespace-nowrap"
      >
        {busy ? "..." : "Ara"}
      </button>
    </div>
  );
}

export default MapSearchBox;
